module.exports = __webpack_public_path__ + "img/p2nav3-h_a3ec895.a3ec8953.png";